// extracted by mini-css-extract-plugin
export default {"container":"UserAreaPage_container__BIIq3"};